export default __webpack_public_path__ + "static/media/spain.e552d93b.svg";